import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import Modal from '../../../../elements/Modal';
import Scrollable from '../../../../elements/Scrollable/Scrollable';
import DirectoryListItem from '../../../EventDirectory/elements/DirectoryListItem/DirectoryListItem';
import styles from './PickSponsorModal.module.scss';

function PickSponsorModal(props) {
    const { event, open, sponsors = [], onSelect, onClose } = props,
        i18n = useI18n();

    return (
        <Modal title={i18n['label.select-organization']} show={open} onClose={onClose} fullScreen={false} fullHeight>
            <Scrollable>
                <ul className="list">
                    {sponsors.map((sponsor) => (
                        <DirectoryListItem key={sponsor.id} className={styles.sponsor} event={event} item={sponsor} href={null} onClick={() => onSelect(sponsor.id)} />
                    ))}
                </ul>
            </Scrollable>
        </Modal>
    );
}

export default PickSponsorModal;
